/**
 * Admin payment accounts ↔ storefront checkout slugs ↔ backend order/revenue enums.
 * Checkout maps types like bank-transfer → bank_transfer on orders; accounts in DB should use API enums.
 */

const FORM_TO_API = {
  bank: 'bank_transfer',
  'bank-transfer': 'bank_transfer',
  bank_transfer: 'bank_transfer',
  easypaisa: 'easypaisa',
  jazzcash: 'jazzcash',
  paypal: 'paypal',
  other: 'easypaisa',
  stripe: 'credit_card',
  card: 'credit_card',
  cod: 'cod',
  digital_wallet: 'easypaisa',
};

const API_TO_FORM = {
  bank_transfer: 'bank',
  digital_wallet: 'easypaisa',
  easypaisa: 'easypaisa',
  jazzcash: 'jazzcash',
  paypal: 'paypal',
  credit_card: 'stripe',
  debit_card: 'stripe',
  card: 'stripe',
  pay_now: 'stripe',
  cod: 'cod',
};

/** POST/PUT /accounts body */
export function toApiPaymentAccountMethod(method) {
  if (method == null || method === '') return method;
  const k = String(method).toLowerCase();
  return FORM_TO_API[k] ?? method;
}

/** AddAccountModal / edit form select values */
export function formPaymentMethodFromApi(method) {
  if (method == null || method === '') return 'bank';
  const k = String(method).toLowerCase();
  return API_TO_FORM[k] ?? method;
}

/**
 * Checkout PaymentContext `method.type` (must match CheckoutPage mapPaymentMethodToAPI keys where applicable).
 */
export function storefrontTypeFromApiAccount(account) {
  const pm = String(account?.paymentMethod || '').toLowerCase();
  if (pm === 'cod') return 'cash-on-delivery';
  if (pm === 'bank' || pm === 'bank_transfer') return 'bank-transfer';
  if (pm === 'digital_wallet') {
    const name = String(account?.name || '').toLowerCase();
    if (name.includes('jazz')) return 'jazzcash';
    if (name.includes('easy')) return 'easypaisa';
    return 'easypaisa';
  }
  if (pm === 'credit_card' || pm === 'pay_now') return 'credit-card';
  if (pm === 'debit_card') return 'debit-card';
  if (pm === 'card' || pm === 'stripe') return 'stripe';
  if (
    pm === 'easypaisa' ||
    pm === 'jazzcash' ||
    pm === 'paypal' ||
    pm === 'other' ||
    pm === 'bitcoin' ||
    pm === 'ethereum' ||
    pm === 'usdt' ||
    pm === 'usdc'
  ) {
    return pm;
  }
  return pm || 'bank-transfer';
}

export function normalizeAccountPayloadForApi(body) {
  if (!body || typeof body !== 'object') return body;
  const out = { ...body };
  if (out.paymentMethod != null && out.paymentMethod !== '') {
    out.paymentMethod = toApiPaymentAccountMethod(out.paymentMethod);
  }
  return out;
}
